import { SignupIntent } from "../../shared/utils/signupIntent";
import { ExploreMergeOption } from "./types";

export const MFP_SIGNUP_INTENT: SignupIntent = "mfp";

export const EXPLORE_MERGE_TITLE = "Where do you want to start?";
export const EXPLORE_MERGE_DESCRIPTION =
  "Tell us what you're building so we can take you to the right place.";
export const SAVE_FAILED_MESSAGE = "Couldn't save your choice. Please try again.";

export const SETTING_UP_ACCOUNT_MESSAGE = "Hang tight! We are setting up your account...";
export const takingYouToMessage = (productName: string) => `Taking you to ${productName}...`;

export const DEFAULT_PRODUCT_FORM_ID = "19b9ce0c-bb39-479d-9910-974c855ae8ae";
export const MAX_HUBSPOT_WAIT_MS = 2_000;

export const EXPLORE_MERGE_OPTIONS: ExploreMergeOption[] = [
  {
    product: "unified",
    title: "Unified",
    description: "Connect your product to customers' systems and keep data up to date",
  },
  {
    product: "agent_handler",
    title: "Agent Handler",
    description: "Give AI agents secure access to tools, actions, permissions, and workflows",
  },
  {
    product: "gateway",
    title: "Gateway",
    description: "Control LLM access, routing, fallbacks, costs, and request visibility",
  },
];
